import React from "react";
import { motion } from "framer-motion";
import { PRICE, WHOP_URL } from "../data/content";

export default function FinalCta() {
    return (
        <section
            data-testid="final-cta"
            className="relative py-28 sm:py-40 border-t border-white/5 overflow-hidden"
        >
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at 50% 80%, rgba(122,0,0,0.32), transparent 60%)",
                }}
            />
            <div className="relative max-w-4xl mx-auto px-6 sm:px-10 text-center">
                <div className="overline mb-6">The Threshold</div>
                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                    className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-[#f4f4f0]"
                >
                    Two men finish this page.
                    <br />
                    <span className="italic text-[#990000]">
                        Only one walks away changed.
                    </span>
                </motion.h2>
                <p className="mt-8 max-w-xl mx-auto text-neutral-400 text-base sm:text-lg">
                    The Varek Code is not for the curious. It is for the man
                    who has decided. Take the door before it closes at the
                    listed price.
                </p>
                <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5">
                    <a
                        href={WHOP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="final-cta-button"
                        className="btn-primary"
                    >
                        <span>Acquire the Code · {PRICE.discounted}</span>
                        <span aria-hidden>→</span>
                    </a>
                    <span className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">
                        {PRICE.original} {PRICE.discountLabel} · Launch window
                    </span>
                </div>
                <div className="mt-16 divider-ornament text-sm">
                    <span>FINIS · CORONAT · OPUS</span>
                </div>
            </div>
        </section>
    );
}
